import { Component, ViewChild } from '@angular/core';
import { ViewController, LoadingController, Events } from 'ionic-angular';
import { AppState } from '../../config/state';
import { PatronProvider } from '../../providers/patron/patron';
import { ToastAlertsProvider } from '../../providers/toast-alerts/toast-alerts';
import { TimeoutFunctionsProvider } from '../../providers/timeout-functions/timeout-functions';
/**
 * Generated class for the CoPopoverKeyboardComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'co-popover-keyboard',
  templateUrl: 'co-popover-keyboard.html',
  inputs: ['cardScannerFocusInput']
})
export class CoPopoverKeyboardComponent {
  libraryCardNumber: string = "";
  isForApp: boolean;
  showNumberpad: boolean = false;
  screenType: string;
  patron: any;
  @ViewChild('cardScannerFocusInput') myInput ;

  constructor(public viewCtrl: ViewController, public state: AppState, public toast: ToastAlertsProvider, private loading : LoadingController, private patronProvider : PatronProvider, private events : Events, private timeout : TimeoutFunctionsProvider) {
    window.hasOwnProperty('cordova')? this.isForApp = true : this.isForApp = false;
    this.events.subscribe('timeoutCalled', ()=> this.timeout.doLogoutFunctions(this));
  }

  close(check) {
    if (check) {
      if(this.libraryCardNumber.length>0){
        this.viewCtrl.dismiss({ info: this.libraryCardNumber }).catch(err=>{});
      }else{
        this.toast.onlyToast('Please enter a card number');
      }
    } else {
      this.viewCtrl.dismiss().catch(err=>{});
    }
  }

  ionViewDidLoad(){
    setTimeout(() => {
      this.myInput.setFocus();
    },1000);
  }

  checkPatronData(info) {
    let loader = this.loading.create({
      content: 'Getting account details...',
    });
    loader.present();
    this.patronProvider.getSummaryDetails(info).then((res) => {
      if (res && res.id != null) {
        // console.log('patron', res);
        this.patron = res;
        // this.state.patron = res;
        // this.loginProvider.login(res.barcode).then(patron => {
        //   this.events.publish('patronLoggedIn', true);
        // })
        // if (this.screenSetting === 'renew') {
        //   console.log('info', info)
        //   this.patronProvider.getCheckouts(info).then(checkouts => {
        //     if (checkouts) {
        //       checkouts.forEach(book => {
        //         book.bib.displayState = 5;
        //         this.renewBookList.push(book);
        //         if (book.bib.upcs.length > 0) {
        //           this.isbnObj[book.bib.id] = { number: book.bib.upcs[0], type: 'upc' };
        //         } else if (book.bib.isbns.length > 0) {
        //           this.isbnObj[book.bib.id] = { number: book.bib.isbns[0], type: 'isbn' };
        //         }
        //       })
        //     }
        //     loader.dismiss();
        //   })
        // } else {
        //   // this.createBookScannerPopover();
        //   loader.dismiss();
        // }
      } else {
        loader.dismiss().catch(err=>{});
        this.toast.onlyToast('Incorrect Information');
        // this.createLibraryCardScannerPopover();
      };
    }).catch((err) => {
      loader.dismiss().catch(err=>{});
      this.toast.onlyToast('Incorrect Information');
    });
  }

  numberKeyPressed(event) {
    if (event === '<') {
      this.libraryCardNumber = this.libraryCardNumber.slice(0, -1);
    } else if (event === '*') {
      console.log('unsupported key', event)
    } else {
      this.libraryCardNumber += event;
    };
  }


}



// WEBPACK FOOTER //
// ./src/components/co-popover-keyboard/co-popover-keyboard.ts